/* src/app/pages/amplify-auth/user-forgot-password/user-forgot-password.component.scss */
/*# sourceMappingURL=user-forgot-password.component.css.map */
